<template>
  <div class="page-content"  data-test-key="category-page">
    
    <SeoMeta v-if="this.tag"
        :title="'TheJobTap.com - Discover ' + Number(tag?.JobListingCount).toLocaleString() + ' ' + tag?.Name + ' job openings'" 
        description=""
    />
    
    <section class="pt-28 lg:pt-44 pb-28 group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 dark:bg-neutral-900 bg-[url('../images/home/page-title.png')] bg-center bg-cover relative" >
        <div class="container mx-auto">
            <div class="grid">
                <div class="col-span-12">
                    <div class="text-center text-white" v-if="tag">
                        <h1 class="mb-4 text-[26px]">Discover  
                        <span class="text-yellow-500 fw-bold">{{ Number(tag?.JobListingCount).toLocaleString() }}</span> 
                        {{ tag?.Name }} job openings</h1>
                        <div class="page-next">
                          <nav class="inline-block" aria-label="breadcrumb text-center">
                            <ol class="flex flex-wrap justify-center text-sm font-medium">
                                <li><router-link to="/job-skills/">Job Skills</router-link></li>
                                <li><i class="bx bxs-chevron-right align-middle px-2.5"></i>{{ tag?.Name }}</li>
                            </ol>
                          </nav>    
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <img rel="prefetch" src="@/assets/images/about/shape.png" alt="header image" class="absolute block bg-cover -bottom-0 dark:hidden" style="width: 100%;">
        <img rel="prefetch" src="@/assets/images/about/shape-dark.png" alt="header image dark" class="absolute hidden bg-cover -bottom-0 dark:block" style="width: 100%;">
      </section>


    <section class="py-12">
        <div class="container mx-auto">
          <div v-if="tagLoading" style="margin-bottom: 300px;">
              <Loader class="mt-15" />
            </div> 
            <div v-else-if="tagLoading == false && tag == null && pageContent == null">
                <p>not found</p>
            </div>
            <div v-else class="grid grid-cols-12  lg:items-center">
              <div class="col-span-12">
                <div class="inline-block items-center text-gray-500 mb-4">
                  <img :src=pageContent?.MainImage style="height: 33px; margin-right: 10px;" alt="alt" class="inline-block" v-if="pageContent?.MainImage && pageContent?.MainImage != null">
                  <h4 class="dark:text-gray-300 inline" style="">{{ pageContent?.Title }} </h4>
                </div>

              </div>

              <div class="col-span-12 lg:col-span-8 mb-10" v-if="pageContentFound == true">
                <div class="" >
                  <div v-if="pageContentFound == true" style="padding-right:25px">
                      <WysiwygViewer class="text-gray-900 dark:text-gray-50" :viewerText="this.pageContent.Content" />
                  </div>
                </div>
              </div>
                
                <div class="col-span-12" :class="pageContentFound == false ? 'lg:col-span-12': 'lg:col-span-4'" style="margin: auto;">
                    <div class="border rounded border-gray-100/50 dark:border-neutral-600">
                        <div class="p-5 border-b border-gray-100/50 dark:border-neutral-600" style="min-height: 250px;">
                            <div class="text-center">
                            <p class="text-gray-500 dark:text-gray-300 text-center mb-5"><b>Combine your skills and search jobs like this.</b></p>
                            <multiselect 
                                class="filter-job-input-box-custom"
                                v-model="this.search.tags" 
                                :options="options" 
                                :searchable="false" 
                                :multiple="true" 
                                :close-on-select="false" 
                                :clear-on-select="true"              
                                :preserve-search="false" 
                                placeholder="Select skills" 
                                :select-label="'Tap to select'"
                                :deselect-label="'Tap to remove'"
                                label="" 
                                track-by="" 
                                :preselect-first="false">
                                <template #selection="{ values, isOpen }" 
                                >
                                    <span class="multiselect__single filter-job-input-box-custom dark:text-gray-200 "
                                        v-if="values.length"
                                        v-show="!isOpen">
                                        {{ values.length }} skills selected: 
                                        <ul class="flex flex-wrap gap-2 mt-2 ">
                                            <li 
                                                class="border p-[6px] border-gray-100/50 rounded group/joblist dark:border-gray-100/20 active"
                                                v-bind:key="tag" 
                                                v-for="tag in this.search.tags" >
                                                <div class="flex items-center ">
                                                  <a href="javascript:void(0)" 
                                                      class="dark:border-gray-100/20">
                                                      <h6 class="mb-0 transition-all duration-300 fs-14 group-data-[theme-color=violet]:group-hover/joblist:text-violet-500 group-data-[theme-color=blue]:group-hover/joblist:text-blue-500">
                                                        {{ tag }}
                                                      </h6>
                                                  </a>
                                                </div>
                                            </li>
                                        </ul>
                                    </span>
                                </template>
                            </multiselect>
                              <div class="mt-3 filter-search-form mt-lg-0">
                                <i class="uil uil-clipboard-notes"></i>
                                <select v-model="this.search.workingStyle" class="w-full filter-job-input-box dark:text-gray-100">
                                    <option value="Remote">Remote</option>
                                    <option value="Hybrid">Hybrid</option>
                                    <option value="Office">Office</option>
                                </select>
                            </div>
                                  <br>
                                  <button @click.stop="searchClickHandle" class="text-white border-transparent group-data-[theme-color=violet]:bg-violet-500 group-data-[theme-color=blue]:bg-blue-500 btn hover:-translate-y-2">Search <i class="align-middle uil uil-rocket ms-1"></i></button>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </section>


                <!-- start job list -->
                    <LandingJobListingSearchResult v-if="this.tag != null"
                    :isRemote = true 
                    :tags= Array(this.tag.Name)
                    >
                    </LandingJobListingSearchResult>
 
    <RelatedArticles  v-if="articles != '' && pageContentFound == true"             
      :tags= Array(pageContent.CategoryName)>
    </RelatedArticles>

                <section class="bg-gray-50 dark:bg-neutral-700" style="padding-top: 40px;" v-if="pageContentFound == true && pageContent.FAQS != null">
                    <div class="container mx-auto">
                        <div class="grid grid-cols-1 gap-5">
                            <div class="mb-5 text-center">
                                <h3 class="mb-3 text-3xl text-gray-900 dark:text-gray-50">Frequently Asked Questions</h3>
                                <p class="mb-5 text-gray-500 whitespace-pre-line dark:text-gray-300">If you're exploring a career in {{ pageContent.CategoryName }}, you may have questions about the skills required, the types of roles available, and remote work opportunities. 
                                  <br/>Below are some of the most common FAQs to help you better understand the {{ pageContent.CategoryName }} job landscape and how to position yourself for success.</p>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-5">
                            <div class="col-span-12 md:col-span-12 lg:col-span-12 ">
                                <!-- Frequently Asked Questions -->
                                <div  style="margin-bottom: 60px">
                                    <div class="accordion" style="max-width:800px" v-if="pageContent.FAQS.Question3">
                                      <details class="dark:bg-neutral-700" v-if="pageContent.FAQS.Question1">
                                          <summary class="text-gray-500 dark:text-white" style="font-family: Inter, sans-serif;font-size: 18px;">{{ pageContent.FAQS.Question1.Question }}</summary>
                                          <p class="text-gray-400 dark:text-gray-300" style="font-family: Inter, sans-serif;font-size: 14px;">{{ pageContent.FAQS.Question1.Answer }}</p>
                                      </details>
                                      <details class="dark:bg-neutral-700" v-if="pageContent.FAQS.Question2">
                                          <summary class="text-gray-500 dark:text-white" style="font-family: Inter, sans-serif;font-size: 18px;">{{ pageContent.FAQS.Question2.Question }}</summary>
                                          <p class="text-gray-400 dark:text-gray-300" style="font-family: Inter, sans-serif;font-size: 14px;">{{ pageContent.FAQS.Question2.Answer }}</p>
                                      </details>
                                      <details class="dark:bg-neutral-700" v-if="pageContent.FAQS.Question3">
                                          <summary class="text-gray-500 dark:text-white" style="font-family: Inter, sans-serif;font-size: 18px;">{{ pageContent.FAQS.Question3.Question }}</summary>
                                          <p class="text-gray-400 dark:text-gray-300" style="font-family: Inter, sans-serif;font-size: 14px;">{{ pageContent.FAQS.Question3.Answer }}</p>
                                      </details>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

</template>
  
  <script>

import Multiselect from 'vue-multiselect'
import { contentAPI } from "@/api/content";
import { jobListingCategoryAPI } from "@/api/jobListingCategory";
import { useStatus } from "@/api/composables/status";
import { useErrorLogger } from "@/api/composables/errorLogging";
import FeedbackNotification from "@/components/FeedbackNotification.vue";
import WysiwygViewer from '@/components/WysiwygViewer.vue'
import router from '@/router';
import LandingJobListingSearchResult from "@/components/JobListingSearchResults/LandingJobListingSearchResult.vue";
import Loader from "@/components/Loader.vue";
import RelatedArticles from "@/components/RelatedArticles.vue";

const pageStatus = useStatus();
const log = useErrorLogger();

  export default{
    name: "JobListingSearchCategoryView",
  components : {
    FeedbackNotification, WysiwygViewer, Multiselect, LandingJobListingSearchResult, Loader, RelatedArticles
  }, 
  data() {
    return {
      notification : {
        text : "",
        level : "",
      },
      tag : null,
      tagLoading : true,
      queryTagName : this.$route.params.category,
      articles : null,      
      articleResultCount : 0,
      articleShowingCount : 0,
      pageContent : null,
      pageContentFound: null,
      options: [],
      search: {
        tags: [this.$route.params.category],
        workingStyle: 'Remote'
      }
    }
  },
  watch:{
    $route (to, from){
      this.queryTagName = decodeURIComponent(this.$route.params.category);
      this.getJobListingCategory();
      this.getJobListingCategories();
      this.getJobListingCategoryContent();
      this.handleSearchArticles();
    }
  },
  created()
  {
      this.getJobListingCategory();
      this.getJobListingCategories();
      this.getJobListingCategoryContent();
      this.handleSearchArticles();
  },
  mounted() {
    document.title = 'TheJobTap.com'
  },
  methods: {
    async handleSetAttendanceRequirement(attendanceRequirement){
    this.search.workingStyle = attendanceRequirement;
  },
    async handleArtlicleClick(articleName){
    this.$router.push('/articles/' + articleName + "/");
  },
    async viewJobListingPageClick(companyName, identifier) {
      this.$router.push('/hiring-companies/' + companyName + '/' + identifier + '/');
    },
    async getJobListingCategory() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategoryByName(this.queryTagName);
          if (result == null){
            //alert("not found");
           this.$router.push('/404/');

          }
          else
          {
            this.tag = result;
          }

          this.tagLoading = false;
        })
      );
      if (!result.success) {
        this.tagLoading = false;
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async handleSearchArticles() {
      this.articlesLoading = true;
      const result = await log.catchPromise(() =>
          pageStatus.observe(async () => {
            const result = await contentAPI.searchArticles(this.queryTagName);
            this.articles = result.Results.slice(0, 3);
            this.articleResultCount = result.ResultCount;
            this.articleShowingCount = result.Results.length; 
            await this.createQueryString();
          })
        );
        this.articlesLoading = false;
        if (!result.success) 
        {
          this.articlesLoading = false;
          this.notification = { text : result.data, level : "error" };        
        }
  },
  async getJobListingCategoryContent() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await contentAPI.getJobListingCategoryContent(encodeURIComponent(this.queryTagName));
          if (result == null){
            this.pageContentFound = false;
          }
          else
          {
            this.pageContentFound = true;
            this.pageContent = result;
            document.title = this.pageContent.Title + ' - TheJobTap.com'

          }
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async getJobListingCategories() {
      const result = await log.catchPromise(() =>
        pageStatus.observe(async () => {
          const result = await jobListingCategoryAPI.getCategories();
          result.forEach((element) => { 
            this.options.push(element.Name);
          })
        })
      );
      if (!result.success) {
        this.notification = { text : result.data, level : "error" };        
      }
    },
    async searchClickHandle() {
      var queryString = "";
      if(this.search.tags.length > 0)
      {
        var isFirst = true;
        this.search.tags.forEach(element => {
          if (element != '')
          {
            if(isFirst)
            {
                isFirst = false;
                queryString = queryString + "tags=" + encodeURIComponent(element);
            }
            else
            {
                queryString = queryString + "&tags=" + encodeURIComponent(element);
            }
          }
        });
      } 
      if(this.search.workingStyle !=  null)
      {
            queryString = queryString + "&workingStyle=" + this.search.workingStyle;
      }
  
      if(queryString != "")   {
        queryString = "?" + queryString;
      }     
      await this.$router.push('/' + queryString);
    },
  }
};
  </script>

  <style lang="scss">


.accordion {
  margin: auto;
	max-width: 500px;
	width: calc(100% - 20px);
}
details {
	background-color: #fff;
	margin-bottom: 10px;
	// filter: drop-shadow(5px 5px 0px #59c9e8);
}
// details:hover {
// 	 filter: drop-shadow(5px 5px 4px #0A0A0A);
// }
details > summary {
	color: #2c3e50;
	padding: 5px 10px;
	font-size: 1.3em;
	cursor: pointer;
}
details > p {
	padding: 5px 10px 10px 20px;
	color: #2c3e50;
	font-size: 1.1em;
}
</style>